import React from 'react';
import { Link } from 'react-router-dom';

const CTA = ({ onScrollToFeatures }) => {
  return (
    <section className="relative py-20 px-6 overflow-hidden">
  {/* Background Layer with Gray + Circles */}
  <div className="absolute inset-0 -z-10 bg-gray">
    {/* Main Large Circle */}
    <svg
      className="absolute top-0 right-0 w-[300px] md:w-[400px] opacity-20"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="200" cy="200" r="200" fill="url(#gradient)" />
      <defs>
        <linearGradient id="gradient" x1="0" y1="0" x2="400" y2="400" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
    </svg>

    {/* Small Floating Circles on Left */}
    <svg className="absolute top-20 left-0 w-24 h-24 opacity-10" viewBox="0 0 100 100" fill="blue">
      <circle cx="50" cy="50" r="50" fill="#3B82F6" />
    </svg>
    <svg className="absolute top-40 left-10 w-16 h-16 opacity-10" viewBox="0 0 100 100" fill="purple">
      <circle cx="50" cy="50" r="50" fill="#8B5CF6" />
    </svg>
    <svg className="absolute top-60 left-20 w-10 h-10 opacity-5" viewBox="0 0 100 100" fill="purple">
      <circle cx="50" cy="50" r="50" fill="#3B82F6" />
    </svg>
  </div>


      {/* Main Content */}
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Left Side */}
        <div className="text-center lg:text-left flex-1">
          <h2 className="text-4xl md:text-5xl font-extrabold text-blue">
            Ready to master a new language?
          </h2>
          <p className="mt-4 text-lg md:text-xl text-charcoal/80">
            Join LangBridge today and start learning smarter.
          </p>

          <div className="flex flex-wrap gap-4 justify-center lg:justify-start mt-8">
            <Link
              to="/register"
              className="bg-blue text-gray px-6 py-3 rounded-lg shadow-lg hover:bg-purple transition font-semibold"
            >
              Get Started
            </Link>
            <button
              onClick={onScrollToFeatures}
              className="border border-blue text-blue px-6 py-3 rounded-lg hover:bg-blue hover:text-gray transition font-semibold"
            >
              See Features
            </button>
          </div>
        </div>

        {/* Query Form */}
        <div className="bg-gray-50 p-6 rounded-2xl  w-full max-w-md">
          <h3 className="text-2xl font-semibold text-blue mb-1">Have a question?</h3>
          <p className="text-sm text-charcoal/70 mb-4">
            We’re happy to help — just drop your message and we’ll get back to you!
          </p>
          <form className="space-y-4">
            <input
              type="text"
              placeholder="Your Name"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue"
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue"
              required
            />
            <textarea
              placeholder="Your Message"
              rows="4"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue"
              required
            />
            <button
              type="submit"
              className="bg-blue text-white w-full py-2 rounded-lg hover:bg-purple transition"
            >
              Submit Query
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CTA;
